import React from 'react';

import { TextField } from '../TextField';
import { EmailFieldProps } from './interface';

export const EmailField = ({ placeholder = 'Email address', ...rest }: EmailFieldProps) => {
  return <TextField {...rest} placeholder={placeholder} type="email" />;
};
